import React from 'react';
import { TextField } from '@material-ui/core';
import { useField, FieldConfig } from 'formik';

const NumberFieldWrapper = ({ name, ...OtherProps }) => {
  const [field, mata] = useField(name);

  const configTextField = {
    ...field,
    ...OtherProps,
    fullWidth: true,
    type: 'number',
    size: 'small',
    variant: 'standard'
  };

  if (mata && mata.touched && mata.error) {
    configTextField.error = true;
    configTextField.helperText = mata.error;
  }

  return <TextField {...configTextField} />;
};

export default NumberFieldWrapper;

// import React from 'react';
// import { TextField } from '@material-ui/core';
// import NumberFormat from 'react-number-format';

// function InputNumber(props) {
//   const { name, label, value, onChange } = props;

//   return (
//     <NumberFormat
//       variant="standard"
//       name={name}
//       label={label}
//       value={value}
//       onChange={onChange}
//       size="small"
//       customInput={TextField}
//       thousandSeparator
//       decimalSeparator="."
//       isNumericString="false"
//     />
//   );
// }

// export default InputNumber;
